import {safelyParsePage} from "@rw/string_utils";
import {Dispatch} from "redux";

import {IStore} from "../../../app/reducers/hybrid_reducer";
import {IRouteState} from "../../../app/routes/data_fetcher/create_app_path_data_fetcher";
import {IServices} from "../../../app/services/IServices";
import {carsCommonUrl} from "../../../app/utils/read_environment_variables";
import {CarMakeTypes} from "../../../cars_data/cars_data";
import {updateMetaData} from "../../../meta_data/actions/update_meta_data";
import {capitalizeFirstLetter} from "../components/CarListDynamic";
import {getOfferListUrl} from "../url_utils/get_offer_list_url";
import {ILocation} from "./fetch_location_by_slug_at_route";

interface IProps {
    offersCount: number;
    currentLocationName: ILocation | null;
    offerType: string;
    page: number;
    type?: CarMakeTypes;
    tag?: string;
    location?: string;
    subLocation?: string;
    subSubLocation?: string;
}

export const getCarListTitle = (props: IProps) => {
    const {currentLocationName, location, subLocation, type, tag, offerType, page, offersCount} = props;
    const locationTitle = currentLocationName && currentLocationName.name ? `${currentLocationName.name} ` : "Polska ";

    if (type) {
        if (location) {
            if (subLocation) {
                return `Samochody osobowe ${capitalizeFirstLetter(type)} w ${capitalizeFirstLetter(subLocation)} na sprzedaż`;
            }
            return `Samochody osobowe ${capitalizeFirstLetter(type)} w ${capitalizeFirstLetter(location)} na sprzedaż`;
        }

        return `Samochody osobowe ${capitalizeFirstLetter(type)} na sprzedaż`;
    }
    if (location) {
        if (subLocation) {
            return `Samochody osobowe w ${capitalizeFirstLetter(subLocation)} na sprzedaż`;
        }
        return `Samochody osobowe w ${capitalizeFirstLetter(location)} na sprzedaż`;
    }

    return `${locationTitle}samochody osobowe na sprzedaż`;
};

export const getCarListDescription = (props: IProps) => {
    const {currentLocationName, type, tag, offerType, page, offersCount, location, subLocation} = props;
    const locationTitle = currentLocationName && currentLocationName.name ? `${currentLocationName.name} ` : "Polsce ";
    if (type) {
        if (currentLocationName) {
            if (location) {
                if (subLocation) {
                    return `Atrakcyjne oferty samochodów marki ${capitalizeFirstLetter(type)} w ${capitalizeFirstLetter(subLocation)} na sprzedaż`;
                }
                return `Atrakcyjne oferty samochodów marki ${capitalizeFirstLetter(type)} w ${capitalizeFirstLetter(location)} na sprzedaż`;
            }
            return `Atrakcyjne oferty samochodów ${capitalizeFirstLetter(type)} w ${capitalizeFirstLetter(locationTitle)} na sprzedaż`;
        }
        return `Atrakcyjne oferty samochodów ${capitalizeFirstLetter(type)} na sprzedaż`;
    }
    if (currentLocationName) {
        if (location) {
            if (subLocation) {
                return `Atrakcyjne oferty samochodów w ${capitalizeFirstLetter(subLocation)} na sprzedaż`;
            }
            return `Atrakcyjne oferty samochodów w ${capitalizeFirstLetter(location)} na sprzedaż`;
        }
        return `Atrakcyjne oferty samochodów w ${capitalizeFirstLetter(locationTitle)} na sprzedaż`;
    }

    return `Wszystkie samochody osobowe dostępne w ${capitalizeFirstLetter(locationTitle)} na sprzedaż`;
};

export const updateCarListMetaData =
    (
        _1: Partial<IServices>,
        route: IRouteState<{
            offerType: string;
            type?: CarMakeTypes;
            tag?: string;
            location?: string;
            subLocation?: string;
            subSubLocation?: string;
        }>
    ) =>
    (dispatch: Dispatch, getState: () => IStore) => {
        const state = getState();
        const page = safelyParsePage(route.query.page);
        const currentLocationName = state.carList.location.location;
        const {location, subLocation, subSubLocation} = route.params;

        const title = getCarListTitle({
            offersCount: state.carList.cars.cars.length || 0,
            currentLocationName,
            offerType: route.params.offerType,
            page,
            type: route.params.type,
            tag: route.params.tag,
            location: location,
            subLocation: subLocation,
            subSubLocation: subSubLocation
        });

        const description = getCarListDescription({
            offersCount: state.carList.cars.cars.length || 0,
            currentLocationName,
            offerType: route.params.offerType,
            page,
            type: route.params.type,
            tag: route.params.tag,
            location: location,
            subLocation: subLocation,
            subSubLocation: subSubLocation
        });

        const listPath = getOfferListUrl({
            offerType: route.params.offerType as any,
            type: route.params.type,
            location,
            subLocation,
            tag: route.params.tag
        });
        const siteBase = carsCommonUrl.replace(/\/+$/, "");
        const absoluteListPath = listPath.startsWith("/") ? listPath : `/${listPath}`;
        const canonical = page <= 1 ? `${siteBase}${absoluteListPath}` : `${siteBase}${absoluteListPath}?page=${page}`;

        const robots = (() => {
            const offersLength = state.carList.cars.cars.length;
            const {page: pageParam} = route.query;
            const isPageIndexable = safelyParsePage(pageParam) < 11;

            switch (true) {
                case offersLength > 0 && isPageIndexable:
                    return "index, follow";
                default:
                    return "noindex, follow";
            }
        })();

        dispatch(
            updateMetaData(title, description, route, {
                canonical,
                robots
            })
        );
        return Promise.resolve(true);
    };
